<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>
        <section class="dp-right">
            <div class="dish-config-container">
                <div class="page-title">
                    <h2>{{ departmentName ? (departmentName + '-学校数据配置') : '学校数据配置' }}</h2>
                </div>

                <div v-if="loading" class="loading-container" style="min-height: 300px;">
                    <div class="loading-content">
                        <div class="loading-text">正在加载数据...</div>
                    </div>
                </div>

                <el-card class="config-card" v-else-if="DepartmentId > 0">
                    <div class="config-form">
                        <el-form :model="formData" :rules="rules" ref="dataForm" label-width="200px">
                            <el-form-item label="本校区教师总数" prop="totalTeachers">
                                <el-input-number v-model="formData.totalTeachers" :min="0" controls-position="right"
                                    class="elegant-input-number">
                                </el-input-number>
                                <span class="unit-text">人</span>
                            </el-form-item>

                            <el-form-item label="学生总数" prop="totalStudents">
                                <el-input-number v-model="formData.totalStudents" :min="0" controls-position="right"
                                    class="elegant-input-number">
                                </el-input-number>
                                <span class="unit-text">人</span>
                            </el-form-item>

                            <el-form-item label="年级总数" prop="totalGrades">
                                <el-input-number v-model="formData.totalGrades" :min="0" :max="12"
                                    controls-position="right" class="elegant-input-number">
                                </el-input-number>
                                <span class="unit-text">个</span>
                            </el-form-item>

                            <el-form-item label="班级总数" prop="totalClasses">
                                <el-input-number v-model="formData.totalClasses" :min="0" controls-position="right"
                                    class="elegant-input-number">
                                </el-input-number>
                                <span class="unit-text">个</span>
                            </el-form-item>

                            <el-form-item label="本校师生比" required class="ratio-item">
                                <div class="ratio-group">
                                    <el-input v-model="formData.ratioLeft" class="ratio-input" readonly>
                                    </el-input>
                                    <span class="ratio-separator">:</span>
                                    <el-input-number v-model="formData.ratioRight" :precision="2" :step="0.1" :min="1"
                                        controls-position="right" class="ratio-input-number">
                                    </el-input-number>
                                </div>
                            </el-form-item>

                        </el-form>
                    </div>

                    <div class="button-group">
                        <el-button type="primary" @click="handleSave" :loading="saving">保存配置</el-button>
                    </div>
                </el-card>

                <!-- 未选择部门时的提示 -->
                <div v-else class="no-department-tip">
                    <p>请选择一个部门查看和配置学校数据信息</p>
                </div>
            </div>
        </section>
    </section>
</template>

<script>
import DepartmentPane from '../../../components/DepartmentPane'
import { getSchoolDataOverviewConfig } from '../../../api/modules/big-screen';
import { saveSchoolDataOverviewConfig } from '../../../api/modules/department';
export default {
    name: 'SchoolDataOverview',
    components: { DepartmentPane },
    data() {
        return {
            DepartmentId: 0,
            saving: false,
            loading: false,
            departmentName: '',
            formData: {
                totalTeachers: 0,
                totalStudents: 0,
                totalGrades: 0,
                totalClasses: 0,
                ratioLeft: 1,
                ratioRight: 1
            },
            rules: {
                totalTeachers: [{ required: true, message: '不能为空', trigger: 'blur' }],
                totalStudents: [{ required: true, message: '不能为空', trigger: 'blur' }],
                totalGrades: [{ required: true, message: '不能为空', trigger: 'blur' }],
                totalClasses: [{ required: true, message: '不能为空', trigger: 'blur' }]
            }
        }
    },
    methods: {
        treeNodeClick(data, node, component) {
            this.DepartmentId = data.value;
            this.departmentName = data.label || '';
            this.getConfigData();
        },
        getConfigData() {
            this.loading = true;
            getSchoolDataOverviewConfig({ departmentId: this.DepartmentId }).then(res => {
                this.loading = false;
                if (res && res.data.response) {
                    var d = res.data.response;
                    this.formData.totalTeachers = d.TotalTeachers || 0;
                    this.formData.totalStudents = d.TotalStudents || 0;
                    this.formData.totalGrades = d.TotalGrades || 0;
                    this.formData.totalClasses = d.TotalClasses || 0;
                    this.formData.ratioLeft = d.RatioLeft || 1;
                    this.formData.ratioRight = d.RatioRight || 1;
                }
            }).catch(() => {
                this.loading = false;
                this.$message.error('获取配置失败，请稍后重试');
            });
        },
        handleSave() {
            this.$refs.dataForm.validate((valid) => {
                if (valid) {
                    this.saving = true;
                    var saveData = {
                        SchoolId: this.DepartmentId,
                        TotalTeachers: this.formData.totalTeachers,
                        TotalStudents: this.formData.totalStudents,
                        TotalGrades: this.formData.totalGrades,
                        TotalClasses: this.formData.totalClasses,
                        RatioLeft: this.formData.ratioLeft,
                        RatioRight: this.formData.ratioRight
                    };
                    saveSchoolDataOverviewConfig(saveData).then(res => {
                        this.saving = false;
                        if (res && res.data.success) {
                            this.$message.success('数据已成功保存');
                            this.getConfigData();
                        } else {
                            this.$message.error(res && res.data.msg || '保存失败，请稍后重试');
                        }
                    }).catch(() => {
                        this.saving = false;
                        this.$message.error('保存失败，请稍后重试');
                    });
                }
            });
        }
    }
}
</script>

<style scoped>
.dish-config-container {
    max-width: 800px;
    margin: 0;
    padding: 20px;
}

.page-title {
    margin-bottom: 20px;
}

.page-title h2 {
    font-size: 20px;
    margin: 0;
    color: #1a1f36;
    font-weight: 600;
}

.config-card {
    margin-bottom: 20px;
}

.config-form {
    margin-bottom: 10px;
}

.config-form /deep/ .el-form-item {
    margin-bottom: 28px;
}

.config-form /deep/ .el-form-item__label {
    color: #666;
    font-weight: 500;
    font-size: 14px;
    padding-right: 20px;
}

.button-group {
    display: flex;
    justify-content: flex-start;
    padding-top: 20px;
    border-top: 1px solid #e8e8e8;
}

.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    border: 1px solid #e8e8e8;
}

.loading-content {
    text-align: center;
}

.loading-text {
    margin-top: 10px;
    color: #666;
}

.no-department-tip {
    background-color: #fff;
    border-radius: 4px;
    padding: 60px 20px;
    text-align: center;
    color: #999;
    border: 1px solid #e8e8e8;
    min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* 输入框规范化 */
.elegant-input-number {
    width: 200px;
}

.elegant-input-number /deep/ .el-input__inner {
    border-radius: 4px;
    text-align: left;
    padding-left: 15px;
}

.unit-text {
    margin-left: 12px;
    color: #606266;
    font-size: 14px;
}

/* 师生比特殊行设计 */
.ratio-group {
    display: flex;
    align-items: center;
    gap: 12px;
}

.ratio-input {
    width: 80px;
}

.ratio-input /deep/ .el-input__inner {
    text-align: center;
    background-color: #f5f7fa;
    color: #909399;
    border-radius: 4px;
    font-weight: bold;
}

.ratio-separator {
    font-size: 16px;
    color: #606266;
    font-weight: bold;
    padding: 0 8px;
}

.ratio-input-number {
    width: 120px;
}

.ratio-input-number /deep/ .el-input__inner {
    border-radius: 4px;
    text-align: center;
}
</style>
